module.exports = __webpack_public_path__ + "img/no_result_still_2x.de8a9bec.webp";